import React, { useState, useEffect } from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Button,
  Row,
  Col,
  Alert
} from "reactstrap"
import { flowRight as compose } from "lodash"
import { useQuery, useMutation } from "@apollo/react-hooks"
import { userInfo } from "utils"
import { Spinner, BarLoader } from "components/spinner"
import { withBasicNotify } from "components/notification"
import withModal from "components/modal"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { USER, UPDATE_USER_PROFILE } from "../gql"

const ProfileContainer = props => {
  const { modal } = props
  const [isFirstLogin, setIsFirstLogin] = useState(
    Boolean(Number(props.match.params.isFirstLogin)) === true
  )
  const { data, loading } = useQuery(USER, { variables: { id: userInfo().id } })
  const originalPassword = useFormInput("")
  const password = useFormInput("")
  const confirmPassword = useFormInput("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [title, setTitle] = useState("")
  const [dept, setDept] = useState("")
  const [
    updateUserInfo,
    { loading: updateLoading, error, data: responseData }
  ] = useMutation(UPDATE_USER_PROFILE, {
    variables: {
      input: {
        email,
        originPassword:
          originalPassword.value !== "" ? originalPassword.value : null,
        newPassword: password.value !== "" ? password.value : null,
        name,
        title,
        dept
      }
    }
  })

  useData(data, setName, setEmail, setTitle, setDept)
  useModal(modal, isFirstLogin, setIsFirstLogin)
  useBread({ to: props.match.url, name: "個人資訊" }, true)

  responseData?.updateUserProfile?.token &&
    localStorage.setItem("token", responseData.updateUserProfile.token)

  const renderContent = () => {
    if (loading) {
      return <Spinner />
    }

    return (
      <div>
        <Form>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>姓名</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              className="ml-3"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </InputGroup>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>Email</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              className="ml-3"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </InputGroup>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>原密碼</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input className="ml-3" type="password" {...originalPassword} />
          </InputGroup>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>變更密碼</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input className="ml-3" type="password" {...password} />
          </InputGroup>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>再次確認密碼</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              className="ml-3"
              type="password"
              {...confirmPassword}
              invalid={password.value !== confirmPassword.value}
            />
          </InputGroup>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>職稱</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              className="ml-3"
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
          </InputGroup>
          <InputGroup style={{ display: "flex", alignItems: "center" }}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div style={{ width: "80px" }}>部門</div>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              className="ml-3"
              value={dept}
              onChange={e => setDept(e.target.value)}
            />
          </InputGroup>
        </Form>
      </div>
    )
  }

  return (
    <div>
      <Card>
        <CardHeader>個人資訊</CardHeader>
        <CardBody>{renderContent()}</CardBody>
        <CardFooter>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col sm={1}>
              <Button
                color="primary"
                onClick={async () => {
                  if (password.value !== confirmPassword.value) {
                    props.notify.warn("密碼不相同，請重新檢查密碼")
                  } else {
                    await updateUserInfo()

                    props.notify.success("個人資訊更新成功")
                  }
                }}
              >
                更新
              </Button>
            </Col>
            <Col></Col>
          </Row>
        </CardFooter>
        <BarLoader loading={updateLoading} />
      </Card>
      {error && <Alert color="danger">錯誤訊息：{`${error}`}</Alert>}
    </div>
  )
}

const useData = (data, setName, setEmail, setTitle, setDept) => {
  useEffect(() => {
    setName(data?.user?.name || "")
    setEmail(data?.user?.email || "")
    setTitle(data?.user?.title || "")
    setDept(data?.user?.dept || "")
  }, [data, setName, setEmail, setDept, setTitle])
}

const useFormInput = (initialValue = "") => {
  const [value, setValue] = useState(initialValue)

  const handleChange = e => {
    setValue(e.target.value)
  }

  return { value, onChange: handleChange }
}

const useModal = (modal, isFirstLogin, setIsFirstLogin) => {
  useEffect(() => {
    if (isFirstLogin) {
      modal.setIsOpen(true)
      modal.setCentered(false)
      modal.setHeaderText("首次登入/密碼仍為系統預設")
      modal.setModalContent("建議您將預設密碼修改為個人密碼")
      modal.setHideCancel(true)
      modal.setOnSubmit(() => {
        setIsFirstLogin(false)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default compose(
  withBasicNotify,
  withModal,
  withBreadcrumb
)(ProfileContainer)
